module.exports = __webpack_public_path__ + "static/media/mypic.e958a457.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mypic.png
// module id = 153
// module chunks = 0